module.exports = "https://static.wanderu.com/ui-react/_next/static/media/refer-a-friend.04cda9c2.svg";